// extracted by mini-css-extract-plugin
module.exports = {"language-switcher":"language-switcher___jYyqy","languageSwitcher":"language-switcher___jYyqy","ru":"ru___3hN8V","en":"en___1UN29","icon":"icon___sqpTZ","label":"label___ZiRZN"};